import { Suspense } from 'react';
import { RouterProvider, createRouter, Link } from '@tanstack/react-router';
import { QueryClientProvider } from '@tanstack/react-query';
import { I18nextProvider, useTranslation } from 'react-i18next';
import { routeTree } from '../routeTree.gen';
import { queryClient } from './providers/queryClient';
import { i18n } from './providers/i18n';

const router = createRouter({
  routeTree,
  defaultNotFoundComponent: () => <NotFoundPage />,
});

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}

export function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <I18nextProvider i18n={i18n}>
        <Suspense fallback={<LoadingScreen />}>
          <RouterProvider router={router} />
        </Suspense>
      </I18nextProvider>
    </QueryClientProvider>
  );
}

function LoadingScreen() {
  const { t } = useTranslation();
  return (
    <div className="flex h-screen w-screen items-center justify-center bg-background">
      <div className="text-text-secondary">{t('common.loading')}</div>
    </div>
  );
}

function NotFoundPage() {
  const { t } = useTranslation();
  return (
    <div className="flex h-screen w-screen flex-col items-center justify-center bg-background">
      <h1 className="text-6xl font-bold text-primary">{t('notFound.title')}</h1>
      <p className="mt-md text-xl text-text-secondary">{t('notFound.message')}</p>
      <p className="mt-sm text-text-muted">{t('notFound.description')}</p>
      <Link
        to="/"
        className="mt-lg rounded-md bg-primary px-lg py-md text-text-inverse hover:bg-primary-hover transition-colors"
      >
        {t('notFound.backToHome')}
      </Link>
    </div>
  );
}
